function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstructionWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.073,
    height: 48,
    viewBox: "0 0 37.073 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "construction-worker (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13004"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47690",
    d: "M88.829 359h-8.585l-6.639 1.5A9.756 9.756 0 0 0 66 370.017v2.935h37.073v-2.935a9.756 9.756 0 0 0-7.605-9.516z",
    transform: "translate(-66 -324.951)",
    style: {
      fill: "#6e83b7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13005"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47691",
    d: "M198.4 365.244a6.251 6.251 0 0 0 6.227-5.807l-1.933-.437h-8.585l-1.934.437a6.251 6.251 0 0 0 6.225 5.807z",
    transform: "translate(-179.864 -324.951)",
    style: {
      fill: "#edeff1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13006"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47692",
    d: "M212 309.188v4.86a4.293 4.293 0 0 0 8.585 0v-4.86z",
    transform: "translate(-197.756 -279.999)",
    style: {
      fill: "#ffd3b3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13007"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47693",
    d: "M212 311.4a10.819 10.819 0 0 0 8.585 0v-2.216H212z",
    transform: "translate(-197.756 -279.998)",
    style: {
      fill: "#fcb98b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13008"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47694",
    d: "M182.756 170v5.854a8.878 8.878 0 1 1-17.756 0V170z",
    transform: "translate(-155.341 -154.39)",
    style: {
      fill: "#ffd3b3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13009"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47695",
    d: "m323 170 2.341 5.854V170z",
    transform: "translate(-297.927 -154.39)",
    style: {
      fill: "#6e83b7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13010"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47696",
    d: "M167.341 170 165 175.854V170z",
    transform: "translate(-155.341 -154.39)",
    style: {
      fill: "#6e83b7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13011"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47697",
    d: "M141.976 174.78h1.366V170h-1.366a.976.976 0 0 0-.976.976v2.824a.976.976 0 0 0 .976.98z",
    transform: "translate(-133.683 -154.39)",
    style: {
      fill: "#ffd3b3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13012"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47698",
    d: "M348.366 174.78H347V170h1.366a.976.976 0 0 1 .976.976v2.824a.976.976 0 0 1-.976.98z",
    transform: "translate(-319.585 -154.39)",
    style: {
      fill: "#ffd3b3"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13013"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47699",
    d: "M366.143 472h.976v2.927h-.976z",
    transform: "translate(-336.861 -426.927)",
    style: {
      fill: "#466089"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13014"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47700",
    d: "M135.857 472h.976v2.927h-.976z",
    transform: "translate(-129.042 -426.927)",
    style: {
      fill: "#466089"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13015"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47701",
    d: "M149 38.244v-3.8a10.439 10.439 0 0 1 20.878 0v3.8z",
    transform: "translate(-140.902 -22.634)",
    style: {
      fill: "#ffe352"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13016"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47702",
    d: "M135.073 140.37a110.916 110.916 0 0 1 13.073 1.135v1.756H122V141.5a110.916 110.916 0 0 1 13.073-1.13z",
    transform: "translate(-116.537 -127.651)",
    style: {
      fill: "#ffe352"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13017"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47703",
    d: "M202.826 24a10.377 10.377 0 0 0-5.748 1.731l.617 9.868h10.263l.617-9.868A10.377 10.377 0 0 0 202.826 24z",
    transform: "translate(-184.29 -22.634)",
    style: {
      fill: "#ffb236"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13018"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47704",
    d: "M211.295 21.563h7.516l.669-10.7a11.811 11.811 0 0 0-8.853 0z",
    transform: "translate(-196.516 -10)",
    style: {
      fill: "#ffe352"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13019"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47705",
    d: "M166 371.365v-6.55l-2.732-.617v7.1a3.9 3.9 0 0 1-3.9 3.9H154.1a3.9 3.9 0 0 1-3.9-3.9v-7.1l-2.732.617v6.55a3.9 3.9 0 0 1-.678 2.2l-.79 1.15v2.927h21.463v-2.927l-.785-1.152a3.9 3.9 0 0 1-.678-2.198z",
    transform: "translate(-138.195 -329.642)",
    style: {
      fill: "#ffe352"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionWorker);
export default __webpack_public_path__ + "static/media/construction-worker.47e94de2369eceb1e127c1a6380c54a5.svg";
export { ForwardRef as ReactComponent };